/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDOCUMENTTYPE } from './IAPDOCUMENTTYPE';
import {
    IAPDOCUMENTTYPEFromJSON,
    IAPDOCUMENTTYPEFromJSONTyped,
    IAPDOCUMENTTYPEToJSON,
} from './IAPDOCUMENTTYPE';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface CreateAndUploadDocumentViewModel
 */
export interface CreateAndUploadDocumentViewModel {
    /**
     * 
     * @type {IAPDOCUMENTTYPE}
     * @memberof CreateAndUploadDocumentViewModel
     */
    documentTypeId: IAPDOCUMENTTYPE;
    /**
     * 
     * @type {string}
     * @memberof CreateAndUploadDocumentViewModel
     */
    documentName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAndUploadDocumentViewModel
     */
    isSelectedForSigning?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAndUploadDocumentViewModel
     */
    isGenerated?: boolean;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof CreateAndUploadDocumentViewModel
     */
    mimeTypeId: IAPMIMETYPE;
    /**
     * 
     * @type {string}
     * @memberof CreateAndUploadDocumentViewModel
     */
    base64Document: string;
}

/**
 * Check if a given object implements the CreateAndUploadDocumentViewModel interface.
 */
export function instanceOfCreateAndUploadDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentTypeId" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "mimeTypeId" in value;
    isInstance = isInstance && "base64Document" in value;

    return isInstance;
}

export function CreateAndUploadDocumentViewModelFromJSON(json: any): CreateAndUploadDocumentViewModel {
    return CreateAndUploadDocumentViewModelFromJSONTyped(json, false);
}

export function CreateAndUploadDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAndUploadDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentTypeId': IAPDOCUMENTTYPEFromJSON(json['DocumentTypeId']),
        'documentName': json['DocumentName'],
        'isSelectedForSigning': !exists(json, 'IsSelectedForSigning') ? undefined : json['IsSelectedForSigning'],
        'isGenerated': !exists(json, 'IsGenerated') ? undefined : json['IsGenerated'],
        'mimeTypeId': IAPMIMETYPEFromJSON(json['MimeTypeId']),
        'base64Document': json['Base64Document'],
    };
}

export function CreateAndUploadDocumentViewModelToJSON(value?: CreateAndUploadDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'DocumentTypeId': IAPDOCUMENTTYPEToJSON(value.documentTypeId),
        'DocumentName': value.documentName,
        'IsSelectedForSigning': value.isSelectedForSigning,
        'IsGenerated': value.isGenerated,
        'MimeTypeId': IAPMIMETYPEToJSON(value.mimeTypeId),
        'Base64Document': value.base64Document,
    };
}

